export const SharedAiButtonStyles = (loading: boolean | undefined) => ({
	background:
		"linear-gradient(270deg, #ff0080, #7928ca, #007cf0, #00dfd8, #ff0080)",
	backgroundSize: "1200% 1200%",
	animation: loading
		? "rainbowShift 2s ease infinite"
		: "rainbowShift 10s ease infinite",
	boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
	transition: "all 0.3s ease-in-out",
	"&:hover": {
		boxShadow: "0 6px 12px rgba(0, 0, 0, 0.3)",
		color: "wheat",
		translate: "scale(1.5)",
	},
	"@keyframes rainbowShift": {
		"0%": { backgroundPosition: "0% 50%" },
		"50%": { backgroundPosition: "100% 50%" },
		"100%": { backgroundPosition: "0% 50%" },
	},
});
